import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { DeviceResponse } from '@/types/apps/device.type';

interface DeviceState {
    detail: DeviceResponse;
}

const initialState: DeviceState = {
    detail: {} as DeviceResponse,
};

export const deviceSlice = createSlice({
    name: 'device',
    initialState,
    reducers: {
        setDeviceDetailAction: (
            state,
            action: PayloadAction<DeviceResponse>
        ) => {
            state.detail = action.payload;
        },
    },
});

export const { setDeviceDetailAction } = deviceSlice.actions;

export default deviceSlice.reducer;
